import { computed, inject, Injectable, signal } from '@angular/core';
import { Theme } from '@tokenbox/domain';
import { ThemesCrudService } from './themes-crud.service.ts';

@Injectable({
  providedIn: 'root',
})
export class SelectedThemeService {
  private themesCrudService = inject(ThemesCrudService);

  public readonly selectedThemeId = signal<string | undefined>(undefined);
  public readonly selectedTheme = computed<Theme | undefined>(() => {
    const selectedThemeId = this.selectedThemeId();
    if (!selectedThemeId) {
      return undefined;
    }
    return this.themesCrudService
      .allThemes()
      .find((theme) => selectedThemeId.includes(theme.id));
  });

  public getSelectedTheme(): Theme {
    const theme = this.selectedTheme();
    if (!theme) {
      throw new Error('No theme selected');
    }
    return theme;
  }

  public getSelectedThemeId(): string {
    const themeId = this.selectedThemeId();
    if (!themeId) {
      throw new Error('No theme selected');
    }
    return themeId;
  }
}
